export const SessionRegionCookieKey = 'session_region_id';
export const ForeverRegionCookieKey = 'forever_region_id';
